import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import JournalsPage from "@/pages/JournalsPage";
import JournalDetailPage from "@/pages/JournalDetailPage";
import SubmitManuscriptPage from "@/pages/SubmitManuscriptPage";
import EditorialBoardPage from "@/pages/EditorialBoardPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/journals" element={<JournalsPage />} />
            <Route path="/journals/:journalId" element={<JournalDetailPage />} />
            <Route path="/submit-manuscript" element={<SubmitManuscriptPage />} />
            <Route path="/editorial-board" element={<EditorialBoardPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
